import { Flame, ChevronsRight, ChevronRight, Minus } from "lucide-react";

export enum EvidencePriorityIcon {
  Flame = "Flame",
  ChevronsRight = "ChevronsRight",
  ChevronRight = "ChevronRight",
  Minus = "Minus",
}

export const EVIDENCE_PRIORITY_ICONS = {
  [EvidencePriorityIcon.Flame]: Flame,
  [EvidencePriorityIcon.ChevronsRight]: ChevronsRight,
  [EvidencePriorityIcon.ChevronRight]: ChevronRight,
  [EvidencePriorityIcon.Minus]: Minus,
};

export type EvidencePriority = {
  priority_id: number;
  priority_name: string;
  color: string;
  icon: EvidencePriorityIcon;
};

export type GetEvidencePriorityQuery = {
  id: number | null;
};

export type GetEvidencePriorityResponse = {
  data: EvidencePriority[];
};

export type GetEvidencePriorityFn = (
  options?: GetEvidencePriorityQuery
) => Promise<GetEvidencePriorityResponse>;
